module.exports = __webpack_public_path__ + "static/media/upload-image4.ac705cfc.svg";